class SideDrawer extends HTMLElement {
  static activeDrawers = new Set();
  static outsideClickHandler = (event) => {
    SideDrawer.activeDrawers.forEach((drawer) => {
      drawer.closeOnClickOutside(event);
    });
  };

  static registerOpen(drawer) {
    SideDrawer.activeDrawers.add(drawer);
    if (SideDrawer.activeDrawers.size === 1) {
      document.addEventListener('click', SideDrawer.outsideClickHandler);
    }
  }

  static unregisterOpen(drawer) {
    SideDrawer.activeDrawers.delete(drawer);
    if (SideDrawer.activeDrawers.size === 0) {
      document.removeEventListener('click', SideDrawer.outsideClickHandler);
    }
  }

  constructor() {
    super();
    
    const self = this; 
    const currentUrl = window.location.href;
    const mainDiv = document.querySelector('main');
    this.target = self.getAttribute('data-target');
    this.openTrigger = document.querySelectorAll(`[data-sidebar-trigger][data-target="${this.target}"]`);
    this.sideBarContainer = this.parentElement;
    this.sideBarContent = this;
    this.close = this.querySelector('.side-close');
    this.size = window.screen.width;
    if (this.shouldReturn()) return;
    this.handleUrlParameters(currentUrl, mainDiv);
    this.setupEventListeners(mainDiv);
  }

  disconnectedCallback() {
    SideDrawer.unregisterOpen(this);
  }

  // Helper method to determine if the size condition should exit early
  shouldReturn() {
    return (
      (this.sideBarContent.classList.contains('mobile-only') && this.size > 750) ||
      (this.sideBarContent.classList.contains('desktop-only') && this.size < 750)
    );
  }

  // Handle URL parameters and update the sidebar and form visibility
  handleUrlParameters(currentUrl, mainDiv) {
    const url = new URL(currentUrl);
    const params = new URLSearchParams(url.search);
    
    if (params.get('customer_posted') === 'true' && url.hash === '#contact_form') {
      if (document.querySelector('newsletter-form[data-inline-landing]')) {
        params.delete('customer_posted');
        url.search = params.toString();
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        return;
      }
      if (this.sideBarContainer?.querySelector('newsletter-form')) {
        this.openDrawer(this.sideBarContainer, mainDiv);
        this.sideBarContainer.querySelector('newsletter-form')?.classList.add('success');
        params.delete('customer_posted');
        url.search = params.toString();
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }
    }
  }

  // Set up event listeners for opening and closing the sidebar
  setupEventListeners(mainDiv) {
    this.openTrigger.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.stopPropagation();
        this.openDrawer(this.sideBarContainer, mainDiv);
        this.sideBarContainer.querySelector('newsletter-form')?.classList.remove('success');
      });
    });

    this.close.addEventListener('click', (event) => {
      event.stopPropagation();
      this.closeDrawer();
    });
  }

  // Open the sidebar drawer
  openDrawer(sideBarContainer, mainDiv) {
    sideBarContainer.classList.add('sidebar-visible');
    sideBarContainer.classList.remove('hidden');
    mainDiv.append(sideBarContainer);
    SideDrawer.registerOpen(this);
  }

  // Close the sidebar drawer
  closeDrawer() {
    this.sideBarContainer.classList.remove('sidebar-visible');
    this.sideBarContainer.classList.add('hidden');
    SideDrawer.unregisterOpen(this);
  }

  // Handle scroll locking if needed (not modified for brevity)
  scrollElements(action, element) {
    if (action === 'lock') {
      scrollLock.disablePageScroll(element);
    } else if (action === 'unlock') {
      scrollLock.enablePageScroll(element);
    }
  }

  // Handle closing the drawer on outside clicks (not modified for brevity)
  closeOnClickOutside(event) {
    if (!this.sideBarContent.contains(event.target) && !Array.from(this.openTrigger).some(trigger => trigger.contains(event.target))) {
      this.closeDrawer();
      this.scrollElements('unlock', this.sideBarContainer);
    }
  }
}

// Define the custom element
customElements.define('side-drawer', SideDrawer);
